import type { TAirbridgeObject } from '@/shared/api'

const EVENT_NAME = 'airbridge-object:emit'

const bus = new EventTarget()

export const emitAirbridgeObject = (object: TAirbridgeObject) => {
  bus.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: object }))
}

export const subscribeAirbridgeObject = (
  handler: (object: TAirbridgeObject) => void,
) => {
  const listener = (event: Event) => {
    handler((event as CustomEvent<TAirbridgeObject>).detail)
  }

  bus.addEventListener(EVENT_NAME, listener)

  return () => {
    bus.removeEventListener(EVENT_NAME, listener)
  }
}
